import { Icon, Icons } from '../Icon';

import { Chip as StyledIcon } from './Chip.styled';
import { Props } from './types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function Chip({ deleteIcon, ...props }: Props) {
  return <StyledIcon deleteIcon={<Icon icon={Icons.removeSolid} />} {...props} />;
}
